import { createContext } from 'react';
import { AxiosResponse } from 'axios';
import { ChatSessionFile } from 'models/Message';
import { FilePreview } from 'models/File';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import utils from 'utils';

type ChatFilesContextProps = {
  files: ChatSessionFile[];
  loading: boolean;
  /** session total, kept in sync locally so the counter doesn't lag behind an action */
  totalFiles: number;
  onContainerScrolled: () => void;
  onFilePreview: (fileId: string) => Promise<AxiosResponse<FilePreview>>;
  onFileAddToDataRoom: (fileId: string) => Promise<void>;
  /** returns the created Data Room nodes, so access can be managed right after saving */
  onFilesAddToDataRoom: (fileIds: string[]) => Promise<DataRoomNode[]>;
  onFileRemove: (fileId: string, removeFromDataRoom?: boolean) => Promise<void>;
  openFilePreview: (fileId: string, fileName?: string) => void;
};

export default createContext<ChatFilesContextProps>({
  files: [],
  loading: false,
  totalFiles: 0,
  onContainerScrolled: utils.noop,
  onFilePreview: utils.noop,
  onFileAddToDataRoom: utils.noop,
  onFilesAddToDataRoom: utils.noop,
  onFileRemove: utils.noop,
  openFilePreview: utils.noop,
});
